module.exports = __webpack_public_path__ + "static/media/shepard'spie.a3c508df.jpg";